module.exports = __webpack_public_path__ + "static/media/22712579_1629551000453418_1155256723585322688_o.d6f19a96.jpg";